import React from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleTHEDATCHAIN = () => {
    navigate('/home');
  };

  return (
    <>
      <div className="landing-page">
        <div className="logo-row">
          <img 
            src="SPNDATlogo.png"
            alt="SPNDAT"
            className="landing-logo spndat-logo" 
            onClick={() => window.location.href = 'https://SPNDAT.com/music'} 
          />
          <img 
            src="THEDATCHAINlogo.png" 
            alt="THEDATCHAIN" 
            className="landing-logo datchain-logo"
            onClick={handleTHEDATCHAIN} 
          />
        </div>
        <img 
          src="StreetFlavorLogoCircle.png" 
          alt="Street Flavor Records" 
          className="landing-logo streetflavor-logo" 
          onClick={() => window.location.href = 'https://StreetFlavorRecords.com/home'} 
        />
      </div>
      <style>{`
        /* Remove default spacing and disable scrolling */
        html, body {
          margin: 0;
          padding: 0;
          overflow: hidden;
          box-sizing: border-box;
        }

        /* Center container both vertically and horizontally, stack column */
        .landing-page {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          background: white;
        }

        /* Top row: SPNDAT on left, DATCHAIN on right */
        .logo-row {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 80%;
          max-width: 1000px;
        }

        /* Logo styling with fadeInUp animation */
        .landing-logo {
          width: 40%;
          max-width: 400px;
          margin: 1rem 0;
          cursor: pointer;
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-radius 0.3s ease;
          opacity: 0;
          transform: translateY(20px) scale(1);
          animation: fadeInUp 1s forwards;
        }

        /* Staggered animation delays by class */
        .spndat-logo {
          animation-delay: 0.3s;
        }
        .datchain-logo {
          animation-delay: 0.5s;
        }
        .streetflavor-logo {
          animation-delay: 0.7s;
        }

        /* Shrink all logos slightly on container hover */
        .landing-page:hover .landing-logo {
          transform: scale(0.95);
        }

        /* Scale up hovered logo and apply circular shadow */
        .landing-logo:hover {
          transform: scale(1.05);
          border-radius: 50%;
        }

        /* Fade in and slide up keyframes */
        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        /* Responsive styling */
        @media (max-width: 400px) {
          .landing-logo {
            width: 80%;
          }
          .logo-row {
            flex-direction: column;
          }
        }
      `}</style>
    </>
  );
};

export default LandingPage;
